import { render } from "./CapitalCard.vue?vue&type=template&id=e2a290e0&scoped=true"
import script from "./CapitalCard.vue?vue&type=script&lang=js"
export * from "./CapitalCard.vue?vue&type=script&lang=js"

import "./CapitalCard.vue?vue&type=style&index=0&id=e2a290e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a290e0"]])

export default __exports__